import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Dialog, InputText, Toast } from "primereact";

// ------------------ COMPONENTES DE BASE--------------------------------
import { useForm } from "../../../../../Base/Hooks/useForm";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { guardarClasificacion } from "../../../../../API/Global/Areas/ClasificacionRequest";

const ClasificacionCRUD = ({
    showDialogCA,
    selected,
    setShowDialogCA,
    getInfo,
}) => {

  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdClasificacion: -1
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    if(selected){
        setValues({
            ...selected,
        })
    }
    setLoading(false);
  };

  const onHide = () => {
    setShowDialogCA(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Clasificacion) {
      error.Clasificacion = true;
      error.error = true;
    }

    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if(!e?.error){
        setLoading(true)
        const Datos = {
            IdClasificacion: values?.IdClasificacion,
            Clasificacion: values?.Clasificacion,
            Descripcion: values?.Descripcion,
            IdUserEdit: userAuth?.IdUser,
            IdUserCreated: userAuth?.IdUser,
        }
       await guardarClasificacion(Datos)
        toastShow(toast, 'success', 'Agregada', 'Clasificación agregada correctamente')

        setTimeout(() => {
            setLoading(false)
            getInfo()
            onHide()
        }, 700);
        


    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialogCA) {
        getValoresIniciales();
    }
  }, [showDialogCA]);

  const dialogTitle = !selected ? "Agregar Clasificación" : "Editar Clasificación";

  return (
    <div>
      <Dialog
        visible={showDialogCA}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
      <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toast} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Clasificacion"
                    value={values.Clasificacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Clasificacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Clasificacion">Clasificación</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>
 
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ClasificacionCRUD;
